// extracted by mini-css-extract-plugin
module.exports = {"bg":"Layout_bg__gNP3j"};